import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { store } from './store';
import './oroPolyfill';

const render = () => {
    let win = null;

    try {
        // console.log("top: ", window === window.top, window === window.parent);
        win = window;
    } catch (ex) {
        win = null;
        console.log("window not found");
    }

    if (win && win === win.top) {
        return ReactDOM.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
            document.getElementById('root')
        );
    } else {
        return ReactDOM.render(
            <React.StrictMode>
                <p className="text-center p-5 h-100 d-flex align-items-center justify-content-center">
                    <span className="d-inline-block mb-5">Website access denied.</span>
                </p>
            </React.StrictMode>,
            document.getElementById('root')
        );
    }
}
render();
store.subscribe(render);

// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
